import React, { useState } from "react";
import { coursesAPI } from "../services/api";
import { useNavigate } from "react-router-dom";
import "../styles/AddCourse.css";
import { FaPlus, FaBook, FaChalkboardTeacher, FaLayerGroup } from "react-icons/fa";
import { toast } from "react-toastify";

const AddCourse = () => {
  const [courseName, setCourseName] = useState("");
  const [courseDescription, setCourseDescription] = useState("");
  const [courseCategory, setCourseCategory] = useState("general"); // New field (mock)
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleAddCourse = async (e) => {
    e.preventDefault();

    if (!courseName.trim() || !courseDescription.trim()) {
      toast.warn("⚠️ يرجى ملء جميع الحقول المطلوبة!");
      return;
    }

    setLoading(true);

    try {
      const courseData = {
        title: courseName,
        description: courseDescription,
        // category: courseCategory // If backend supports it later
      };

      await coursesAPI.create(courseData);
      toast.success("✅ تمت إضافة الدورة بنجاح!");
      navigate("/courses");
    } catch (error) {
      console.error("❌ Error adding course:", error);
      toast.error("❌ فشل إنشاء الدورة. يرجى المحاولة لاحقاً.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-course-container fade-in">
      <div className="add-course-header">
        <h2><FaBook /> إنشاء دورة جديدة</h2>
        <p>قم بتجهيز المحتوى التعليمي لطلابك بسهولة</p>
      </div>

      {/* Main Form Section */}
      <div className="course-form-card">
        <form onSubmit={handleAddCourse}>
          <div className="form-group">
            <label><FaChalkboardTeacher /> اسم الدورة</label>
            <input
              type="text"
              className="form-control"
              placeholder="مثال: أساسيات الفيزياء الحديثة"
              value={courseName}
              onChange={(e) => setCourseName(e.target.value)}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label><FaLayerGroup /> التصنيف (اختياري)</label>
            <select
              className="form-control"
              value={courseCategory}
              onChange={(e) => setCourseCategory(e.target.value)}
            >
              <option value="general">عام</option>
              <option value="science">علوم</option>
              <option value="math">رياضيات</option>
              <option value="languages">لغات</option>
              <option value="programming">برمجة</option>
            </select>
          </div>

          <div className="form-group">
            <label>وصف الدورة</label>
            <textarea
              className="form-control"
              placeholder="اكتب نبذة مختصرة عما سيتعلمه الطالب..."
              rows="5"
              value={courseDescription}
              onChange={(e) => setCourseDescription(e.target.value)}
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? "جارٍ الإنشاء..." : <><FaPlus /> نشر الدورة</>}
            </button>
          </div>
        </form>
      </div>

      {/* Preview Section */}
      <div className="course-preview-card">
        <div className="preview-header">
          <h3>معاينة البطاقة</h3>
          <small>كيف ستظهر الدورة للطلاب</small>
        </div>
        <div className="preview-content">
          <div className="preview-mockup">
            <div className="mockup-thumbnail">
              <FaBook />
            </div>
            <div className="mockup-details">
              <h3>{courseName || "اسم الدورة"}</h3>
              <p>{courseDescription || "وصف الدورة سيظهر هنا..."}</p>
              <span className="badge">{courseCategory}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCourse;
